module.exports = __webpack_public_path__ + "img/header-weddingRingsMillgrif.8ee634f.jpg";